<template>
  <div class="dashboard-container">
    <selectCompany @onSelect="onSelectCompany" />
    <el-row class="panel-group" :gutter="40">
      <el-col v-if="ability(['TransactionSummary', 'TransactionSales'])" :xs="24" :sm="24" :lg="24" class="card-panel-col">
        <transactionStatusPanel />
      </el-col>
      <el-col v-if="ability(['TransactionSummary', 'TransactionSales'])" :xs="24" :sm="24" :lg="24" class="card-panel-col">
        <transactionChart />
      </el-col>
      <el-col v-if="ability(['TransactionSummary', 'TransactionSales'])" :xs="24" :sm="24" :md="24" class="card-panel-col">
        <transactionTable />
      </el-col>
    </el-row>

    <el-row class="panel-group" :gutter="40">
      <el-container class="px-3">
        <p class="text-h5">機台狀況概覽</p>
      </el-container>
      <el-col v-if="ability(['MvmsList', 'MvmsMap'])" :xs="12" :sm="12" :md="24" class="card-panel-col">
        <mvmStatusPanel />
      </el-col>
      <el-col v-if="ability(['MvmsList', 'MvmsMap'])" :xs="24" :sm="24" :md="24" class="card-panel-col">
        <mvmTable />
      </el-col>
    </el-row>

    <!-- mymvm -->
    <el-row class="panel-group" :gutter="40">
      <el-container class="px-3">
        <p class="text-h5">我的機台</p>
      </el-container>
      <el-col :xs="24" :sm="24" :md="24" class="card-panel-col">
        <myMvmStatusPanel />
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" class="card-panel-col">
        <myMvm />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import selectCompany from '@/components/select/companiesGlobal.vue';
import BarChart from '@/components/Chart/BarChart';
import PieChart from './components/PieChart';
import pie from './components/pie';
import transactionChart from './components/transactionChart.vue';
import mvmStatusPanel from './components/mvmStatusPanel.vue';
import mvmTable from './components/mvmTable.vue';
import transactionTable from './components/transactionTable.vue';
import transactionStatusPanel from './components/transactionStatusPanel.vue';
import myMvm from './components/myMvm.vue';
import myMvmStatusPanel from './components/myMvmStatusPanel.vue';
import CountTo from 'vue-count-to';
const methods = {
  ...mapActions('transaction', ['getSales']),
  async onSelectCompany() {},
  async init() {},
  ability(pathName) {
    if (this.roles[0] === 'admin') {
      return true;
    }
    const ability = this.abilities.filter((route) => {
      for (const path of pathName) {
        if (route.name === path) {
          if (route.meta.action.r) {
            return true;
          }
        }
      }
    });
    if (ability.length) return true;
    return false;
  },
};
export default {
  name: 'Dashboard',
  components: {
    CountTo,
    BarChart,
    PieChart,
    transactionChart,
    pie,
    mvmStatusPanel,
    transactionStatusPanel,
    mvmTable,
    transactionTable,
    myMvm,
    myMvmStatusPanel,
    selectCompany,
  },
  data() {
    return {
      loaded: false,
      salesByTime: [],
      salesQt: [],
      thisMonth: 0,
      allSum: 0,
      lastMonth: 0,
      mvms: [],
      onlineMvm: 0,
      offlineMvm: 0,
      noAuthMvm: 0,
      saleChartDatas: {},
      saleChartLabels: [],
      mvmChartDatas: {},
    };
  },
  computed: {
    ...mapGetters(['name', 'abilities', 'roles']),
    total() {
      return this.Cash + this.EasyCard + this.iCash + this.iPass + this.QrCode;
    },
  },
  mounted() {
    this.init();
  },
  methods,
};
</script>

<style lang="scss" scoped>
.dashboard {
  &-container {
    padding: 32px;
    background-color: rgb(240, 242, 245);
    position: relative;
  }
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
.panel-group {
  margin-top: 18px;

  .card-panel-col {
    margin-bottom: 32px;
  }

  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
    border-color: rgba(0, 0, 0, 0.05);

    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }

      .icon-people {
        background: #40c9c6;
      }

      .icon-message {
        background: #36a3f7;
      }

      .icon-money {
        background: #f4516c;
      }

      .icon-shopping {
        background: #ceae1e;
      }
    }

    .icon-people {
      color: #40c9c6;
    }

    .icon-message {
      color: #36a3f7;
    }

    .icon-money {
      color: #f4a851;
    }

    .icon-shopping {
      color: #bf4934;
    }

    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }

    .card-panel-icon {
      float: left;
      font-size: 48px;
    }

    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;

      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }

      .card-panel-num {
        font-size: 25px;
      }
    }
  }
}

@media (max-width: 550px) {
  .card-panel-description {
    display: none;
  }

  .card-panel-icon-wrapper {
    float: none !important;
    width: 100%;
    height: 100%;
    margin: 0 !important;

    .svg-icon {
      display: block;
      margin: 14px auto !important;
      float: none !important;
    }
  }
}
</style>
